import { render } from "./OcDetalle.vue?vue&type=template&id=02c51947&scoped=true"
import script from "./OcDetalle.vue?vue&type=script&lang=js"
export * from "./OcDetalle.vue?vue&type=script&lang=js"

import "./OcDetalle.vue?vue&type=style&index=0&id=02c51947&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c51947"]])

export default __exports__